import { ChangeDetectorRef, Component, NgZone, OnInit, OnDestroy, ViewChild, HostListener, Directive, AfterViewInit, OnChanges } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
import { Observable, Subject, BehaviorSubject, Subscription } from 'rxjs/Rx';

import { AuthService } from './../../../services/auth.service';
import { SharedService } from './../../../services/shared.service';
import { UserManageInfo } from './../../../models/userManageInfo';
import { OperatoreService } from '../../../services/operatore.service';
import { ImpiantoService } from '../../../services/impianto.service';
import { TipoServizio } from '../../../models/servizio';
import swal from 'sweetalert2';
import { AccordionDirective } from "../../../shared/accordion";

TipoServizio

export interface BadgeItem {
  type: string;
  value: string;
}
export interface Saperator {
  name: string;
  type?: string;
}
export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  show?: boolean;
  masterState?: string;
}
 
export interface Menu {
  masterState?: string;
  state: any;
  name: string;
  type: string;
  icon: string;
  show: boolean;
  badge?: BadgeItem[];
  saperator?: Saperator[];
  children?: ChildrenItems[];
}


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})

export class AppSidebarComponent implements OnInit {

  public CurrentUser: UserManageInfo = new UserManageInfo();

  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;

  private MENUITEMS: Menu[];
  private _mobileQueryListener: () => void;
  public NomeCognome: string = null;

  public userOperatoreTotem: boolean = false;
  public servizi: any;
  public eTipoServizio = TipoServizio;
  public impiantoConServiziCredito: boolean = false;

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,private authService: AuthService, private sharedService: SharedService ,private operatoreService: OperatoreService, private impiantoService: ImpiantoService) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.authService.UserConnected.subscribe((data: UserManageInfo) => {

      this.CurrentUser = data;
      this.createMenu();
      if (data) {
        if (this.CurrentUser.Ruolo == "Impianto") {
          this.impiantoService.getCostoServizi()
            .subscribe(result => {
              this.servizi = result;
              for (var i = 0; i < this.servizi.length; i++) {
                if (this.servizi[i].TipoServizio == this.eTipoServizio.Credito) {
                  this.impiantoConServiziCredito = true;
                  break;
                }
              }
              this.createMenu();
            },
              err => {
                if (err != null && err.error && err.status != 401) {
                  console.log("err: ", err); swal("Lettura Servizi", "Errore nella lettura dei servizi", "error")
                }
              });

        }
      }
    });

   

  }
   
  private createMenu() {
    this.MENUITEMS = [
      {
        masterState: '',
        state: 'dashboard',
        name: 'Dashboard',
        type: 'link',
        icon: 'home',
        show: true
      },
      {
        masterState: '',
        state: 'grid-admins',
        name: 'Amministratori',
        type: 'link',
        icon: 'security',
        show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "SuperAdmin" : false
      },
      {
        masterState: '',
        state: 'grid-clients',
        name: 'Clienti',
        type: 'link',
        icon: 'person',
        show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "SuperAdmin" || this.CurrentUser.Ruolo == "Admin" : false
      },
      {
        masterState: '',
        state: 'grid-implants',
        name: 'Impianti',
        type: 'link',
        icon: 'fitness_center',
        show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "SuperAdmin" || this.CurrentUser.Ruolo == "Admin" || this.CurrentUser.Ruolo == "Cliente" : false
      },
      {
        masterState: '',
        state: 'grid-offerte',
        name: 'Gestisci offerte',
        type: 'link',
        icon: 'local_offer',
        show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "SuperAdmin" || this.CurrentUser.Ruolo == "Admin" : false
      },

      {
        masterState: '',
        state: 'grid-users',
        name: 'Utenti',
        type: 'link',
        icon: 'person',
        show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "Impianto" : false
      },
      (() => {
        const isImpianto = (this.CurrentUser) ? this.CurrentUser.Ruolo == "Impianto" : false;
        const tcd = (isImpianto && this.CurrentUser.TipoCarteDaGestire) ? this.CurrentUser.TipoCarteDaGestire : {} as any;
        const children: ChildrenItems[] = [
          { masterState: '',       state: 'crea-carta-ricarica',              name: 'Crea carta ricarica',     show: isImpianto && this.impiantoConServiziCredito },
          { masterState: '/carte/', state: 'crea-carta-standalone',           name: 'Gestione abbonamento',    show: isImpianto && this.CurrentUser.GestisceStandAlone },
          { masterState: '/carte/', state: 'crea-carta-tempo',                name: 'Crea carta tempo',        show: isImpianto && tcd.CartaTempo },
          { masterState: '/carte/', state: 'crea-carta-set',                  name: 'Crea carta set',          show: isImpianto && tcd.CartaSet },
          { masterState: '/carte/', state: 'crea-carta-tempo-silicloud',      name: 'Crea carta Tempo',        show: isImpianto && tcd.CartaTempoSilicloud },
          { masterState: '/carte/', state: 'crea-carta-set-v23',              name: 'Crea carta set V2.3',     show: isImpianto && tcd.CartaSetV23 },
          { masterState: '/carte/', state: 'crea-carta-settaggio-costo',      name: 'Crea carta Costo',        show: isImpianto && tcd.CartaSettaggioCosto },
          { masterState: '/carte/', state: 'crea-carta-settaggio-fuori-servizio', name: 'Crea carta Fuori servizio', show: isImpianto && tcd.CartaSettaggioFuoriServizio },
          { masterState: '/carte/', state: 'crea-carta-settaggio-gare',       name: 'Crea carta Gare',         show: isImpianto && tcd.CartaSettaggioGare },
          { masterState: '/carte/', state: 'crea-carta-settaggio-modo',       name: 'Crea carta Modo',         show: isImpianto && tcd.CartaSettaggioModo },
          { masterState: '/carte/', state: 'crea-carta-settaggio-wifi',       name: 'Crea carta Set WiFi',     show: isImpianto && tcd.CartaSettaggioWifi },
          // -------------- WIP ----------------
          // { masterState: '/carte/', state: 'crea-carta-impianto-gruppo-servizio-sottogruppo', name: 'Crea carta Set Macchina', show: isImpianto && tcd.CartaImpiantoGruppoServizioSottogruppo },
          //------------------------------------
        ];
        return {
          masterState: '',
          state: 'creazione-carte',
          name: 'Creazione carte',
          type: 'sub',
          icon: 'credit_card',
          show: children.some(c => c.show),
          children: children
        };
      })(),
      {
        masterState: '',
        state: 'ricarica-carta',
        name: 'Ricarica carta',
        type: 'link',
        icon: 'local_atm',
        show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "Impianto" && this.impiantoConServiziCredito == true : false
      },
      {
        masterState: '',
        state: 'gestisci-servizi-cash',
        name: 'Gestisci servizi cash',
        type: 'link',
        icon: 'money',
        show: (this.CurrentUser) ? (this.CurrentUser.Ruolo == "Impianto" && this.CurrentUser.HasBloccoCartaCash) : false
      },
      {
        masterState: '',
        state: 'grid-storico-movimenti',
        name: 'Storico movimenti',
        type: 'link',
        icon: 'history',
        show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "Impianto"
          || this.CurrentUser.Ruolo == "SuperAdmin"
          || this.CurrentUser.Ruolo == "Admin" : false
      },
      {
        masterState: '',
        state: 'grid-servizi',
        name: 'Anagrafica servizi',
        type: 'link',
        icon: 'settings',
        show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "SuperAdmin" || this.CurrentUser.Ruolo == "Admin" : false
      },
      {
        masterState: '',
        state: 'grid-costo-servizi',
        name: 'Costo servizi',
        type: 'link',
        icon: 'monetization_on',
        show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "Impianto" : false
      },
      {
        masterState: '',
        state: 'statistiche',
        name: 'Statistiche casse',
        type: 'link',
        icon: 'unarchive',
        show: (this.CurrentUser) ? ((this.CurrentUser.Ruolo == "Impianto" && (this.userOperatoreTotem) || this.CurrentUser.Ruolo == "Cliente") && (this.CurrentUser.HasCasse)) : false
      },
      {
      masterState: '',
      state: 'gestione-casse-crediti',
      name: 'Stato casse',
      type: 'link',
      icon: 'savings',
      show: (this.CurrentUser) ? (this.CurrentUser.Ruolo == "Impianto" || this.CurrentUser.Ruolo == "Cliente") && (this.CurrentUser.HasCasse) : false
      },
      {
        masterState: '',
        state: 'operatori',
        name: 'Operatori',
        type: 'link',
        icon: 'security',
        show: (this.CurrentUser) ? (this.CurrentUser.Ruolo == "Impianto" && this.CurrentUser.IsAmministratore == true) || this.CurrentUser.Ruolo == "Cliente" : false
      },
      {
        masterState: '',
        state: 'cambio-impianto-carta',
        name: 'Cambio Impianto Carta',
        type: 'link',
        icon: 'credit_card',
        show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "SuperAdmin" : false
      },
      // {
      //   masterState: '',
      //   state: 'resetta-carta',
      //   name: 'Reset Carta',
      //   type: 'link',
      //   icon: 'credit_card',
      //   show: (this.CurrentUser) ? this.CurrentUser.Ruolo == "SuperAdmin" || this.CurrentUser.Ruolo == "Impianto" : false
      // },
      {
        masterState: '',
        state: () => this.goToSiliCloud(),
        name: 'SiliCloud',
        type: 'action',
        icon: 'cloud',
        show: (this.CurrentUser) 
        ? this.CurrentUser.Ruolo == "SuperAdmin" || ((this.CurrentUser.Ruolo == "Impianto" || this.CurrentUser.Ruolo == "Cliente") && this.CurrentUser.IsSilicloudAbilitato) 
        : false
      }
    ];

  }

  ngOnInit() {
    this.isUserOperatoreTotem();
    
  }

  getMenuitem(): Menu[] {
    return this.MENUITEMS;
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  private isUserOperatoreTotem() {
    this.operatoreService.isUserOperatoreTotem()
      .subscribe(src => {
        this.userOperatoreTotem = src;
        this.createMenu();
      });
  }

  private goToSiliCloud(){
    this.sharedService.goToSiliCloud()
      .subscribe(src => {
        window.location.href = src;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full/sidebar/sidebar.component.ts